<template>
  <HeadClone @back="back" @next="next" v-model:next="nextArr">{{ activeList[active].title }}</HeadClone>
  <div class="fixed l r zIndex1 t mt44 ">
    <div class="BGwhite">
      <div class="ml15 flex mr15 BGf0 radius30 nowrap">
        <img src="@/assets/img/icon-search.png" class="width22px pad2 ml10 mr10 pointer" @click="getList" alt="">
        <input type="text" class="flex1 size14" style="height:34px;background:none;" placeholder="请输入搜索关键词" v-model="keyword"
          v-on:keyup.enter="getList" key="1" />
        <img src="@/assets/img/icon32.png" v-if="keyword" @click="keyword='';getList();"
          class="width22px pad4 BGwhite opacity7 radius20 ml10 mr6 pointer" alt="">
      </div>
    </div>
    <!-- <dl class="selectList" :class="{open:screenIndex!=-1}" @click="screenIndex=-1">
      <dt class="flex BGwhite C000 right" style="padding-top:11px">
        <div :class="{Con:screenIndex == index}" @click.stop="screenIndexbanner = screenIndex==index?-1:index" v-for="item,index in screenList" :key="index">
          <span class="b500">{{item.name}}</span><van-icon name="play" class="rotate90" />
        </div>
      </dt>
      <dd class="BGf5 pad25 BGwhite grid3 gap18 line45 center" v-show="index == screenIndex" v-for="item,index in screenList" :key="index" >
        <div class="BGwhite radius5" :class="{'em110 BGon Cfff':screen_ids == child.id}" v-for="(child,childIndex) in item.child" :key="childIndex" @click="screen_id(child.id)">{{child.name}}</div>
      </dd>
    </dl> -->
  </div>
  <div class="height40px" v-if="screenList.length"></div>
  <ImgBox :imgStatus="!keyword" :title="activeList[active].title" :banner='banner'>
  </ImgBox>
  <van-empty description="暂无数据" class="mt50" v-if="list.length==0" />
  <div class="height100px" v-if="list.length==0"></div>
  <div ref="wrapper" class="scroll" v-else  @scroll.passive="isScrollBottom">
    <div class="pad15 ohide size14">

      <!-- <img v-if="!keyword" :src="banner" :onerror="imgError" class="banner"> -->
      <!-- <div class="mt50"></div> -->
      <div v-for="item,index in list" :key="index" class="mb45 mt20"
        @click="$router.push({path:'/join/detail',query:{id:item.id,cate_id:item.cate_id}})">
        <div class="flex initial between list" v-if="active==0">
          <img :src="item.pic" class="pro" :onerror="imgError" alt="">
          <div class="width64">
            <p class="ellipsis em110 mb10 mt15 b500">{{item.name}}</p>
            <p class="ellipsis opacity5 mb10">ID:{{item.no}}</p>
            <!-- <div class="flex between opacity7">
                <p>{{item.nickname}}</p>
                <p class="opacity8">{{item.add_time}}</p>
              </div> -->
          </div>
        </div>
        <div class="flex initial between list" v-if="active==1">
          <img :src="item.pic" class="pro" :onerror="imgError" alt="">
          <div class="width64">
            <p class="ellipsis em110 mb10 mt15 b500">{{item.name}}</p>
            <p class="ellipsis opacity5 mb10 flex">
              <span v-for="v in item.screen" :key="v">{{ v }}&nbsp;</span>
            </p>
          </div>
        </div>
        <!-- <div class="size15 b500 flex nowrap" v-if="active==1">
            <img :onerror="userError" class="height20px width20px radius20" :src="item.pic" alt="">
            <p class="Con width20 ml8 ellipsis">{{item.name}}</p>
            <div class="flex around width40 nowrap"><p class="ellipsis" v-for="sc,scIndex in item.screen" :key="scIndex">{{sc}}</p></div>
            <p class="opacity5 flex1" style="text-align:right">{{item.add_time}}</p>
          </div> -->
        <div class="flex initial between list" v-if="active==2">
          <img :src="item.pic" class="pro" :onerror="imgError" alt="">
          <div class="width64">
            <p class="ellipsis em110 mb10 mt15 b500">{{item.name}}</p>
            <p class="ellipsis opacity5 mb10 flex">
              <span v-for="v in item.screen" :key="v">{{ v }}&nbsp;</span>
            </p>
          </div>
        </div>
        <!-- <div class="flex size15 between nowrap" v-if="active==2">
            <p class="Con b500 ellipsis width18">{{item.name}}</p>
            <div class="flex around width40 nowrap"><p class="ellipsis" v-for="sc,scIndex in item.screen" :key="scIndex">{{sc}}</p></div>
            <p class="opacity6">{{item.add_time}}</p>
          </div> -->
        <hr class="mt14" />
      </div>
    </div>
  </div>
  <div type="primary" class="fixed l r b mb60 auto part10 width94" round block @click="apply" v-if="detail.is_deliver==0 && $store.state.nokey ">
    
    <span>
      我要加盟
    </span>
  </div>

  <div type="primary" class="fixed l r b mb60 auto part10 width94 opacity3" round block v-if="detail.is_deliver==1 && $store.state.nokey">审核中</div>
  <div type="primary" class="fixed l r b mb60 auto part10 width94 filterGray opacity3" round block v-if="detail.is_deliver==2 && $store.state.nokey">
    已加盟</div>
  <div v-show="$store.state.nokey" @click="$router.push({path:'/feedback',query:{column_type:5,cate_id:active+1}})"
    class="fixed l b mb126 Cfff zIndex4" style="border-radius:0 20px 20px 0;padding:10px 18px;background:rgba(8,109,143,.45)">意见反馈</div>
  <van-tabbar v-if="$store.state.nokey">
    <van-tabbar-item  v-show="active==0" @click="onActiveChange(item.value,true)" v-for="item,index in activeList.slice(1,3)"
      :key="index" class="Con"><img :src="item.img" class="height24px relative block auto" style="bottom:2px" alt="">{{item.title}}</van-tabbar-item>
    <van-tabbar-item  v-show="active==2" @click="onActiveChange(item.value,true)" v-for="item,index in activeList.slice(0,2)"
      :key="index" class="Con"><img :src="item.img" class="height24px relative block auto" style="bottom:2px" alt="">{{item.title}}</van-tabbar-item>
    <van-tabbar-item  v-show="active==1" @click="onActiveChange(item.value,true)" v-for="item,index in [activeList[2],activeList[0]]"
      :key="index" class="Con"><img :src="item.img" class="height24px relative block auto" style="bottom:2px" alt="">{{item.title}}</van-tabbar-item>
  </van-tabbar>

</template>
<script>
import HeadClone from "@/components/headClone"
import { showConfirmDialog } from "vant"
export default {
  name: 'Home',
  components: { HeadClone },
  data () {
    return {
      demo: true,
      count: null,
      screen_ids: '',
      isLoading: false,
      showBottom: false,
      list: [],
      screenList: [], screenIndex: -1,
      active: 0, activeList: [
        { title: '产品加盟', img: require('@/assets/img/join1.png'), value: 0 },
        { title: '人才加盟', img: require('@/assets/img/join2.png'), value: 1 },
        { title: '国会加盟', img: require('@/assets/img/join3.png'), value: 2 }
      ],
      detail: {},
      page: 1,
      activeArr: [],
      nextActiveArr: [],
      nextArr: false,
      banner: ''
    }
  },
  // watch: {
  //   active (v) {
  //     //this.$router.replace当前页面不进行更新
  //     this.activeArr.push(v)
  //     console.log(this.activeArr)
  //     this.$router.replace({ query: { active: v } })
  //     this.getconfig();
  //     this.isLoading = false
  //     this.page = 1
  //     this.getList()
  //   }
  // },
  methods: {
    getBanner () {
      const data = {
        column_type: 5,
        cate_id: this.active == 0 ? 1 : this.active == 1 ? 2 : 3
      }
      this.ajax.post('api/getbanner', data).then(res => {
        this.banner = res.data.thumb
      })
    },
    apply () {
      if (!this.$store.state.loginInfo.token) {
        showConfirmDialog({
          title: '是否登录'
        })
          .then(() => {
            // on confirm
            this.$router.push({ path: '/login', query: { column_type: 5 } })
          })
        return
        // return this.$router.push({path:'/login',query:{column_type:5}})
      }
      this.$router.push({ path: '/join/edit', query: { cate_id: this.active + 1 } })
      // if(this.detail.is_concept==0){
      //   this.$router.push({path:'/join/sense',query:{cate_id:this.active+1}})
      // }else{
      //   this.$router.push({path:'/join/edit',query:{cate_id:this.active+1}})
      // }
    },
    getconfig () {
      this.ajax.post("joins/getconfig", { cate_id: this.active + 1 }).then(({ data }) => {
        this.detail = data
      })
    },
    screen_id (id) {
      this.screen_ids = id; this.screenIndex = -1;
      this.getList(1)
    },
    getList (page) {
      if (this.isLoading) return;
      this.isLoading = true;
      this.page = page || this.page;
      let list = this.list;
      if (this.page > 1) {
        if (this.page > this.count) {
          return this.page = this.count;
        }
      } else {
        list = [];
      }
      this.ajax.post("joins/getlist", { cate_id: this.active + 1, page: this.page, keyword: this.keyword, screen_ids: this.screen_ids }).then(({ data, count }) => {
        this.list = list.concat(data);
        this.count = count;
      }).finally(() => {
        this.isLoading = false;
      })
      this.ajax.post("joins/getscreen", { cate_id: this.active + 1 }).then(({ data }) => {
        this.screenList = data;
      })
    },
    isScrollBottom () {
      // 是否滚动到了底部
      this.box = this.$refs.wrapper
      var clientHeight = this.box.clientHeight
      var scrollTop = this.box.scrollTop
      var scrollHeight = this.box.scrollHeight
      if (scrollTop + clientHeight == scrollHeight) {
        this.getList(this.page + 1);
      }
    },
    changeActive () {
      this.getList()
    },
    onActiveChange (v, isTabBar = false) {

      if (v == 'undefined') {
        history.go(-1)
      } else {

        if (isTabBar == true) {
          this.active = v
          this.activeArr.push(v)
          // if(this.$route.query.active?this.$route.query.active:0 == this.activeArr[this.activeArr.length - 1]) {
          //   this.activeArr.push(v)
          // }else {
          //   this.activeArr.push(this.$route.query.active)
          //   this.activeArr.push(v)
          //   console.log(this.activeArr)
          // }
        } else {
          this.active = v
        }
        this.$router.replace({ query: { active: v } })
      }
      this.getconfig();
      this.page = 1
      this.isLoading = false
      this.list = []
      this.getList()
      this.getBanner()
    },
    back () {
      if (this.activeArr.length == 0) {
        history.go(-1)
      } else {
        let v = null
        if (this.activeArr.length == 1) {
          v = this.activeArr[0]
        } else {
          v = this.activeArr[this.activeArr.length - 2]
        }
        this.nextActiveArr.push(this.activeArr[this.activeArr.length - 1])
        this.onActiveChange(v, false)
        this.activeArr.splice(this.activeArr.length - 1, 1)
        this.nextArr = true
      }
    },
    next () {
      if (this.nextActiveArr.length == 0) {
        history.forward()
      } else {
        const v = this.nextActiveArr[this.nextActiveArr.length - 1]
        this.activeArr.push(v)
        this.onActiveChange(v, false)
        this.nextActiveArr.pop()
        if (this.nextActiveArr.length == 0) {
          if (history.state.forward) {
            this.nextArr = true
          } else {
            this.nextArr = false
          }
        }
      }
      // this.active = this.active<2?this.active+1:0;
      // this.getList()
    },
  },
  created () {
    let { active } = this.$route.query;
    if (active) {
      active = Number(active);
      this.activeArr.push(active)
      this.active = active;
    }
    if (history.state.forward) {
      this.nextArr = true
    }
    this.getList()
    this.getconfig()
    this.getBanner()
  }
}
</script>
<style scoped>
.banner {
  width: 100%;
}
</style>
<style lang="scss">
.selectList{
  background: rgba(0,0,0,.2); backdrop-filter: blur(10px);
  box-shadow: inset 0 50px 0 white;
  &.open{
    min-height: calc(100vh - 125px);
  }
  dt{
    padding-right: 25px;
    div{ margin-left: 14px; background: #f5f5f5; padding:5px 25px; border-radius: 8px; margin-bottom: 5px; }
    .Con{
      border-radius: 8px 8px 0 0; box-shadow: 0 8px 0 #f5f5f5;
    }
  }
  dd{
    border-radius: 0 0 8px 8px;
  }
}

.list{
  .pro{
    width:32%;border:solid 1px #dbdbdb; border-radius: 8px;
    height: 100px;
  }
}
// .img_box{
  
// }
.scroll{
  padding-bottom: 10vw;
}

</style>
